import { render, staticRenderFns } from "./AvisoConsulta.vue?vue&type=template&id=f7ba4b46&scoped=true&"
import script from "./AvisoConsulta.vue?vue&type=script&lang=js&"
export * from "./AvisoConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ba4b46",
  null
  
)

export default component.exports